import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {RegisterPage} from "../register/register";
import {InitStepCounterPage} from "../init-step-counter/init-step-counter";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";
import {InitSummaryPage} from "../init-summary/init-summary";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {ApiInitProvider} from "../../providers/api-init/api-init";

/**
 * Generated class for the InitPreferenceStep2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-preference-step2',
  templateUrl: 'init-preference-step2.html',
})
export class InitPreferenceStep2Page {

  nextHref: any = InitSummaryPage;
  errorVisible: boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public initWizard: InitWizardProvider,
    private alertCtrl: AlertController,
    private contentTranslation: ContentTranslationProvider,
    private loadingCtrl: LoadingController,
    public apiInit: ApiInitProvider,
  ) {
  }

  selectValue(val: number) {
    if(this.initWizard.question2 == val) {
      this.initWizard.question2 = null;
      return false;
    }
    this.initWizard.question2 = val;
    this.errorVisible = false;
  }

  goNext() {
    if(!this.initWizard.question2) {
      this.errorVisible = true;
    } else {

      let iloader = this.loadingCtrl.create();
      iloader.present();

      this.apiInit.finishInitialization(this.initWizard).then(success => {
        this.navCtrl.setRoot(AppDashboardPage);
        iloader.dismiss();
      }, err => {
        iloader.dismiss();
        let alert = this.alertCtrl.create({
          title: 'Error',
          message: 'Server error',
          buttons: ['OK']
        });
        alert.present();
      })
    }
  }

  showInfo() {
    var alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Modal question 2 Info Title'),
      subTitle: this.contentTranslation.translateContent('Modal question 2 Info Text'),
      buttons: [
        {
          text: this.contentTranslation.translateContent('OK').toUpperCase(),
        },
        {
          text: '×',
          cssClass: 'close-button'
        }],
      cssClass: 'ip-alert ip-with-close meillitus-popup'
    });
    alert.present();

  }

}



// WEBPACK FOOTER //
// ./src/pages/init-preference-step2/init-preference-step2.ts